import ExternalScriptLoader from 'sharedController/externalScriptLoader';

const TRUSTPILOT_BOOTSTRAP = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

export function loadTrustpilotIfPresent() {
    if (!document.querySelector('.trustpilot-widget[data-template-id]')) return;
    new ExternalScriptLoader().loaded(TRUSTPILOT_BOOTSTRAP);
}

export function trackTrustpilotFooterClicks() {
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.trustpilot-wrapper--footer')) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'trustpilot_footer_click' });
    });
}
